import {z} from 'zod';
import {COUNTRY_LANGUAGES_CODES} from '@/utils/constants/globalConstants';

export const getDefaultValues = (countryCode = 'MX') => {
  const languages = COUNTRY_LANGUAGES_CODES[countryCode] || [];
  const content = {};

  languages.forEach((lang) => {
    content[lang.code] = {
      tierName: '',
      displayDescription: '',
      imageTierIcon: '',
      bannerHeader: '',
      bannerDescription: '',
      bannerImage: '',
      detailsDescription: '',
      detailsTermsAndConditions: '',
      detailsImage: ''
    };
  });

  return {
    tierId: '',
    activities: [
      {
        activityID: '',
        multiplier: 0
      }
    ],
    content
  };
};

export const defaultValues = getDefaultValues('MX');

const imageFieldSchema = z.union([
  z.string().nonempty(),
  z.number().positive()
]);

const displayItemSchema = z.object({
  tierName: z.string().nonempty('Tier Name is required'),
  displayDescription: z.string().max(30).optional(),
  imageTierIcon: imageFieldSchema,
  bannerHeader: z.string().nonempty('Banner Header is required'),
  bannerDescription: z.string().optional(),
  bannerImage: imageFieldSchema,
  detailsDescription: z.string().nonempty(),
  detailsTermsAndConditions: z.string().optional(),
  detailsImage: imageFieldSchema
});

export const activityItemSchema = z.object({
  activityID: z.string().nonempty(),
  multiplier: z.number().positive()
});

export const getCreateTierSchema = (countryCode = 'MX') => {
  const languages = COUNTRY_LANGUAGES_CODES[countryCode] || [];
  const contentSchema = {};

  languages.forEach((lang) => {
    contentSchema[lang.code] = displayItemSchema;
  });

  return z.object({
    tierId: z.string().nonempty(),
    activities: z.array(activityItemSchema).min(1),
    content: z.object(contentSchema)
  });
};

export const createTierSchema = getCreateTierSchema('MX');
